import { css } from '@emotion/react';

export const textStyles = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
  width: 100%;
`;

export const lineClampStyles = css`
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-break: break-word;
  overflow-wrap: break-word;
`;

export const tooltipBodyStyles = css`
  word-break: break-word;
  white-space: pre-wrap;
`;
